(() => {
  'use strict';
  const desktop = matchMedia('(min-width: 981px)');
  const items = [...document.querySelectorAll('.nav-item.has-mega')];
  const setOpen = (item, open) => { item.classList.toggle('open', open); item.querySelector('.nav-link')?.setAttribute('aria-expanded', String(open)); };
  const closeMenus = except => items.forEach(item => { if (item !== except) setOpen(item, false); });
  items.forEach(item => {
    const link = item.querySelector('.nav-link');
    link?.addEventListener('click', event => { if (!desktop.matches) return; event.preventDefault(); const open = !item.classList.contains('open'); closeMenus(item); setOpen(item, open); });
    item.addEventListener('mouseenter', () => { if (desktop.matches) { closeMenus(item); setOpen(item, true); } });
    item.addEventListener('mouseleave', () => { if (desktop.matches) setOpen(item, false); });
    item.addEventListener('focusout', event => { if (!item.contains(event.relatedTarget)) setOpen(item, false); });
  });
  document.addEventListener('click', event => { if (!event.target.closest('.nav-item.has-mega')) closeMenus(); });
  const drawer = document.querySelector('.mobile-drawer');
  const overlay = document.querySelector('.nav-overlay');
  const trigger = document.querySelector('.menu-toggle');
  const closer = document.querySelector('.drawer-close');
  const drawerBackground = () => [...document.querySelectorAll('.shipping-bar, .site-header, main, .site-footer')];
  let drawerReturnFocus = null;
  const drawerFocusables = () => drawer ? [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter(element => !element.closest('[hidden]')) : [];
  const setDrawer = open => {
    const wasOpen = drawer?.classList.contains('open');
    if (open && !wasOpen) drawerReturnFocus = document.activeElement;
    drawer?.classList.toggle('open', open);
    overlay?.classList.toggle('open', open);
    trigger?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('drawer-open', open);
    drawerBackground().forEach((element) => {
      element.inert = open;
      if (open) {
        element.dataset.drawerAriaHidden = element.getAttribute('aria-hidden') ?? '';
        element.setAttribute('aria-hidden', 'true');
      } else {
        const previous = element.dataset.drawerAriaHidden;
        if (previous) element.setAttribute('aria-hidden', previous);
        else element.removeAttribute('aria-hidden');
        delete element.dataset.drawerAriaHidden;
      }
    });
    if (!open && wasOpen) (drawerReturnFocus instanceof HTMLElement ? drawerReturnFocus : trigger)?.focus();
  };
  trigger?.addEventListener('click', () => { setDrawer(true); closer?.focus(); });
  closer?.addEventListener('click', () => setDrawer(false));
  overlay?.addEventListener('click', () => setDrawer(false));
  const toggles = [...document.querySelectorAll('.drawer-toggle')];
  toggles.forEach(toggle => toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') !== 'true'; toggles.forEach(other => { other.setAttribute('aria-expanded', 'false'); const panel = document.getElementById(other.getAttribute('aria-controls')); if (panel) panel.hidden = true; }); toggle.setAttribute('aria-expanded', String(open)); const panel = document.getElementById(toggle.getAttribute('aria-controls')); if (panel) panel.hidden = !open; }));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeMenus();
      setDrawer(false);
      return;
    }
    if (event.key !== 'Tab' || !drawer?.classList.contains('open')) return;
    const focusable = drawerFocusables();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  if ('IntersectionObserver' in window) {
    document.documentElement.classList.add('reveal-enabled');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); }), { threshold: .12 });
    document.querySelectorAll('.reveal').forEach(element => observer.observe(element));
  }
})();
